import React, {
    useEffect
} from "react"
import {
    useSelector
} from "react-redux"
import Notifications from "../../../helpers/Notifications"
import sign from "../../../helpers/sign"

const TextSigner = (props) => {
    const {
        textSignerWorkingState,
        setTextSignerWorkingState,
        textListToSign, // Стейт для запуска и получения признака окончания выполнения
        textSignaturesList, // Стейт для выгрузки подписей
        setTextSignaturesList,
        setIsSigning = null// Стейт для прерывания лодинга в случае ошибки подписи
    } = props

    const { systemEnvironment } = useSelector((state) => state.userReducer)

    useEffect(() => {
        if(textListToSign?.length){
            if (textListToSign.length && textSignaturesList.length) {
                if (textSignaturesList.length == textListToSign?.length) {
                    setTextSignerWorkingState(false) // конец выполнения
                } else if (textSignaturesList.length < textListToSign?.length) {
                    signText(textListToSign[textSignaturesList.length])
                }
            }
        }
    }, [textSignaturesList])

    useEffect(() =>{
        if(textSignerWorkingState && textListToSign?.length){
            try {
                if (textListToSign.length)
                    signText(textListToSign[0])
                else 
                    setTextSignerWorkingState(false) // конец выполнения
            } catch (e) {
                Notifications.errorNotice(e.message, null, 5)
            }
        }
    }, [textSignerWorkingState])

    function signText(text){
        sign(window.btoa(unescape(encodeURIComponent(text))), false, systemEnvironment.cp_address_n).then(result => {
            if (result.res) {
                setTextSignaturesList([...textSignaturesList, result.res.data.cms])
            }
            else if (result.error){
                    setIsSigning(false)
                    setTextSignaturesList([])
                    setTextSignerWorkingState(null)
            }
        })
    }

    return null
}
export default TextSigner
